import { render, staticRenderFns } from "./paytip.vue?vue&type=template&id=6b6442ce&scoped=true"
import script from "./paytip.vue?vue&type=script&lang=js"
export * from "./paytip.vue?vue&type=script&lang=js"
import style0 from "./paytip.vue?vue&type=style&index=0&id=6b6442ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6442ce",
  null
  
)

export default component.exports